module.exports = __webpack_public_path__ + "img/img88.5e5e9306.png";